import * as React from 'react';
import { InstantSearch, Configure, Hits } from 'react-instantsearch-dom';

import { SearchBox } from './search-box';
import { Results } from './results';
import { ResultsWrapper } from './results-wrapper';
import { SearchHit } from './search-hit';
import { searchClient } from '../../utilities';
import { Query } from './query';

function SearchBar() {
  return (
    <div className="flex flex-col justify-center w-full mx-auto text-sm tracking-wide bg-white max-w-7xl">
      <InstantSearch indexName="shopify_products" searchClient={searchClient}>
        <Configure hitsPerPage={8} />
        <SearchBox className="w-full rounded-none sm:text-sm sm:leading-5 form-input" />
        <div className="relative">
          <Results>
            <ResultsWrapper>
              <h3 className="px-4 pb-4 text-base text-left uppercase border-b">
                Products
              </h3>
              <Hits hitComponent={SearchHit} />
              <Query />
            </ResultsWrapper>
          </Results>
        </div>
      </InstantSearch>
    </div>
  );
}

export { SearchBar };
